import React, { useEffect, useRef, RefObject, useState, FC } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, PaperProps, IconButton } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { AuthService } from 'services/AuthService'
import { useSnackbar } from 'notistack'
import Draggable from 'react-draggable'
import ListTransfer from 'components/transfer/ListTransfer'
import CloseIcon from '@mui/icons-material/Close'

interface AssignPermissionsProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    select?: any;
    reloading: () => void;
    views?: any;
}

function PaperComponent(props: PaperProps) {
    const nodeRef = useRef<HTMLDivElement>(null);
    return (
        <Draggable
            nodeRef={nodeRef as RefObject<HTMLDivElement>}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

const AssignViews: FC<AssignPermissionsProps> = ({ open, setOpen, select, reloading, views }) => {
    const { t } = useTranslation()
    const [elementos, setElementos] = useState([]);
    const [selectedElements, setSelectElements] = useState([]);
    const { enqueueSnackbar } = useSnackbar()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!open) return;

        try {
            if (select.length > 0) {
                const normalizedViews = views.map((perm: any) => ({
                    ...perm,
                    id: perm.id || perm.view_id // Usar id si existe, sino permission_id
                }));
                setElementos(normalizedViews)
                const normalizedSelectedViews = select[0]?.views.map((perm: any) => ({
                    ...perm,
                    id: perm.id || perm.view_id
                }));
                setSelectElements(normalizedSelectedViews)
            }
        } catch (error) {
            console.error('Error fetching permissions:', error)
        }
    }, [open, select, views])

    const AddAssignViews = async () => {
        const authService = new AuthService()
        const accessToken = localStorage.getItem('access_token')
        if (!accessToken) {
            console.error("No access token found in localStorage")
            return
        }

        try {
            setLoading(true)
            await authService.profile.assignView({
                profile_id: select[0].profile_id,
                view_ids: selectedElements.map((item: ViewItem) => item.id)
            }); // Explicitly typing the response
            //console.log('Assign Permissions:', data)
            // if(data.status === 200){
            enqueueSnackbar(t('profiles.table.dialog.assign_views.messages.success'), { variant: 'success' })
            // }
            reloading()
            setOpen(false)
        } catch (error) {
            console.error("Error:", error)
            enqueueSnackbar(t('profiles.table.dialog.assign_views.messages.error'), { variant: 'error' })
        } finally {
            setLoading(false)
        }
        console.log('selectedElements', selectedElements)
    }

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            maxWidth="md"
            fullWidth
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                {t('profiles.table.dialog.assign_views.title')}
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={() => setOpen(false)}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent>
                <ListTransfer
                    loading={loading}
                    allItems={elementos}
                    right={selectedElements}
                    setRight={setSelectElements}
                    textLeft={t('profiles.table.dialog.assign_views.available')}
                    textRight={t('profiles.table.dialog.assign_views.assigned')}
                    textSelected={t('general.transfer_list.selected')}
                />
            </DialogContent>
            <DialogActions>
                <Button variant='contained' onClick={() => setOpen(false)} color="error">
                    {t('profiles.table.dialog.assign_views.buttons.cancel')}
                </Button>
                <Button variant='contained' onClick={() => AddAssignViews()} color="primary" loading={loading}>
                    {t('profiles.table.dialog.assign_views.buttons.assign')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export { AssignViews }